
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { userManager, useAppAuth } from '../../logic/imports';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

/**
 * ProtectedRoute using Auth0 authentication
 * 
 * Waits for Auth0 to finish loading and checks if the user is authenticated.
 * If not authenticated, redirects to the login page.
 * 
 * If authenticated, ensures that the user's profile is loaded and portfolio
 * session initialized before rendering the protected content.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAppAuth();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initializeProfile = async () => {
            if (!isAuthenticated || isLoading) return;

            try {
                // Load user data from server
                await userManager.load();
                setIsInitialized(true);
            } catch (error) {
                console.error('Failed to initialize user data/portfolio:', error);
            }
        };

        initializeProfile();
    }, [isAuthenticated, isLoading]);

    const loadingTsx = (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            color: '#ffa600ff',
            fontSize: '18px'
        }}>
            Loading...
        </div>
    );

    if (isLoading || !isInitialized) {
        return loadingTsx;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
}